var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3332 3.16607V7.16607M15.3332 7.16607H11.3332M15.3332 7.16607L12.2398 4.2594C11.5233 3.54254 10.6369 3.01887 9.6633 2.73725C8.68967 2.45563 7.66058 2.42523 6.67203 2.6489C5.68348 2.87258 4.7677 3.34302 4.01015 4.01634C3.25259 4.68967 2.67795 5.54392 2.33984 6.4994M0.666504 13.8327V9.83273M0.666504 9.83273H4.6665M0.666504 9.83273L3.75984 12.7394C4.47634 13.4563 5.36275 13.9799 6.33638 14.2616C7.31 14.5432 8.3391 14.5736 9.32765 14.3499C10.3162 14.1262 11.232 13.6558 11.9895 12.9825C12.7471 12.3091 13.3217 11.4549 13.6598 10.4994",
    stroke: "#374151",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableRefreshIcon);
export default __webpack_public_path__ + "static/media/table-refresh-icon.74e455bb6ce4628eb40c7d40845f2caf.svg";
export { ForwardRef as ReactComponent };